module.exports = __webpack_public_path__ + "img/flame.d4bceb74.png";